// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"039d23b3","231":"59aa9aff","299":"5033697f","363":"e23f3ac4","852":"24f73f73","911":"03b09230"}[chunkId] + ".css";
};